import { useRouter } from 'next/router';
import { FormattedMessage } from 'react-intl';

import { convertEndTime, isBetweenTimes } from '@/helper/checkTimes';
import convertTimeFormat from '@/helper/convertTimeFormat';

const todayIndex = (new Date().getDay() + 6) % 7;

const Hours = (props: any) => {
  const { facilityData } = props;
  const gateAccessHours = facilityData?.attributes?.Open_Hours;

  const officeHours = facilityData?.attributes?.Store_Hours;

  let gateAccessDaysOfWeek = Object.keys(gateAccessHours);
  gateAccessDaysOfWeek = gateAccessDaysOfWeek.filter((day) => day !== 'id');
  let officeDaysOfWeek = Object.keys(officeHours);
  officeDaysOfWeek = officeDaysOfWeek.filter((day) => day !== 'id');
  const { locale }: any = useRouter();

  return (
    <>
      <div className="dropdown-center sv-gateAccess-select mb-3">
        <button
          className="btn btn-outline-dark dropdown-toggle w-100 d-flex align-items-center justify-content-between"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <div className="hours-dropdown-text">
            <span className="sv-storeAddress text-black">
              <FormattedMessage id="gateAccess" />
            </span>
            <span
              className={
                isBetweenTimes(
                  gateAccessHours[gateAccessDaysOfWeek[todayIndex]]
                )
                  ? 'blinking-dot'
                  : 'dot'
              }
            ></span>
            {isBetweenTimes(
              gateAccessHours[gateAccessDaysOfWeek[todayIndex]]
            ) ? (
              <span className="sv-hours-blue-text">
                {convertEndTime(
                  gateAccessHours[gateAccessDaysOfWeek[todayIndex]],
                  locale
                )}
              </span>
            ) : (
              convertTimeFormat(
                gateAccessHours[gateAccessDaysOfWeek[todayIndex]],
                locale,
                locale === 'en' ? 'Open ' : 'Ouvert '
              )
            )}
          </div>
        </button>
        <ul className="dropdown-menu bg-white w-100">
          {gateAccessDaysOfWeek.map(
            (day, index) =>
              day !== 'id' && (
                <li
                  key={index}
                  className={todayIndex === index ? 'sv-current-day' : ''}
                >
                  <div className="dropdown-item d-flex align-items-center justify-content-between py-2">
                    <span>
                      <span
                        className="sv-hour-day"
                        style={{
                          fontWeight: todayIndex === index ? 'bold' : 'normal',
                        }}
                      >
                        <FormattedMessage id={`days.${day}`} />
                      </span>
                      <span className="sv-store-description ms-1">
                        {todayIndex === index &&
                          `(${locale === 'en' ? 'Today' : "Aujourd'hui"})`}
                      </span>
                    </span>
                    <span className="sv-hour-time">
                      {convertTimeFormat(gateAccessHours[day], locale)}
                    </span>
                  </div>
                </li>
              )
          )}
        </ul>
      </div>

      <div className="dropdown-center sv-hours-select">
        <button
          className="btn btn-outline-dark dropdown-toggle w-100 d-flex align-items-center justify-content-between"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <div className="hours-dropdown-text">
            <span className="sv-storeAddress text-black">
              <FormattedMessage id="officeHours" />
            </span>
            <span
              className={
                isBetweenTimes(officeHours[officeDaysOfWeek[todayIndex]])
                  ? 'blinking-dot'
                  : 'dot'
              }
            ></span>
            {isBetweenTimes(officeHours[officeDaysOfWeek[todayIndex]]) ? (
              <span className="sv-hours-blue-text">
                {convertEndTime(
                  officeHours[officeDaysOfWeek[todayIndex]],
                  locale
                )}
              </span>
            ) : (
              <span className="sv-hours-open-text">
                {convertTimeFormat(
                  officeHours[officeDaysOfWeek[todayIndex]],
                  locale,
                  locale === 'en' ? 'Open ' : 'Ouvert '
                )}
              </span>
            )}
          </div>
        </button>
        <ul className="dropdown-menu bg-white w-100">
          {officeDaysOfWeek.map(
            (day, index) =>
              day !== 'id' && (
                <li
                  key={index}
                  className={todayIndex === index ? 'sv-current-day' : ''}
                >
                  <div className="dropdown-item d-flex align-items-center justify-content-between py-2">
                    <span>
                      <span
                        className="sv-hour-day"
                        style={{
                          fontWeight: todayIndex === index ? 'bold' : 'normal',
                        }}
                      >
                        <FormattedMessage id={`days.${day}`} />
                      </span>
                      <span className="sv-store-description ms-1">
                        {todayIndex === index &&
                          `(${locale === 'en' ? 'Today' : "Aujourd'hui"})`}
                      </span>
                    </span>
                    <span className="sv-hour-time">
                      {(officeHours[day] &&
                        convertTimeFormat(officeHours[day], locale)) ||
                        (locale === 'en' ? 'Closed' : 'Fermé')}
                    </span>
                  </div>
                </li>
              )
          )}
        </ul>
      </div>
    </>
  );
};

export default Hours;
